import type { Api } from '@pflegenavi/shared-frontend/platform';
import { get, getApiBaseUrl } from '@pflegenavi/shared-frontend/platform';
import type { Tenant } from '@pflegenavi/frontend/tenant';
import type { AuthenticationContext } from '@pflegenavi/frontend/authentication';
import type { OnboardingControllerResultTypes } from '@pflegenavi/service-provider-shared/api-endpoints';
import { OnboardingControllerDefinition } from '@pflegenavi/service-provider-shared/api-endpoints';

export interface IOnboardingApi extends Api {
  getNursingHomeList(): Promise<
    OnboardingControllerResultTypes['getNursingHomeList']
  >;
}

export class OnboardingApi implements IOnboardingApi {
  baseUrl: string;

  getNursingHomeList: IOnboardingApi['getNursingHomeList'];

  constructor(
    tenantId: Tenant,
    public authContext: AuthenticationContext,
    apiUrl?: string
  ) {
    this.baseUrl = getApiBaseUrl(tenantId, apiUrl);

    this.getNursingHomeList = get({
      authContext,
      url: `${this.baseUrl}/${OnboardingControllerDefinition.controller}/${OnboardingControllerDefinition.endpoints.getNursingHomeList.url}`,
    });
  }
}
